import React from 'react';
import { 
  Warehouse, TrendingUp, Package, Zap, Shield, Globe, AlertTriangle, 
  CheckCircle, ArrowRight, Truck, Thermometer, Lock, Users, Plane,
  Heart, Pill, Building, FlaskRound
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const Services = () => {
  const detailedServices = [
    {
      icon: Warehouse,
      title: 'Field Stocking Locations (FSLs)',
      description: 'Strategic FSL locations across America for rapid deployment',
      features: [
        'Multiple locations nationwide',
        'Reduced lead times',
        'Critical inventory management',
        'Real-time stock visibility',
        'Custom stocking programs',
        '24/7 access availability'
      ],
      image: 'https://images.pexels.com/photos/4481259/pexels-photo-4481259.jpeg'
    },
    {
      icon: TrendingUp,
      title: 'Supply Chain Management',
      description: 'End-to-end supply chain optimization and visibility',
      features: [
        'Demand forecasting',
        'Inventory optimization',
        'Network design',
        'Cost reduction strategies',
        'Performance analytics',
        'Continuous improvement'
      ],
      image: 'https://images.pexels.com/photos/6169668/pexels-photo-6169668.jpeg'
    },
    {
      icon: Package,
      title: 'Warehousing & Distribution',
      description: 'Advanced warehousing with seamless order fulfillment',
      features: [
        'Climate-controlled facilities',
        'Inventory control & visibility',
        'Data and physical security',
        'Integrated transportation',
        'Value-added services',
        'Reporting & compliance'
      ],
      image: 'https://images.pexels.com/photos/4487365/pexels-photo-4487365.jpeg'
    },
    {
      icon: Zap,
      title: 'Rush Delivery Services',
      description: 'Time-critical delivery with guaranteed performance',
      features: [
        'Same-day delivery options',
        'Dedicated courier services',
        'Critical parts management',
        'Real-time tracking',
        'Proof of delivery',
        '99.8% on-time rate'
      ],
      image: 'https://images.unsplash.com/photo-1569153689628-df82366aa3bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxkZWxpdmVyeSUyMHZhbiUyMGRyaXZpbmclMjBmYXN0JTIwc3BlZWQlMjBtb3Rpb24lMjBibHVyfGVufDB8fHx8MTc2ODEzMTE2N3ww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Truck,
      title: 'Dedicated Routes / Lanes',
      description: 'Your own private fleet, efficiently operated by Sabey',
      features: [
        'Equipment planning',
        'Route optimization',
        'Driver hiring & management',
        'Liability risk management',
        'Regulatory compliance',
        'Fleet monitoring'
      ],
      image: 'https://images.pexels.com/photos/2199293/pexels-photo-2199293.jpeg'
    },
    {
      icon: Heart,
      title: 'Medical & Healthcare Logistics',
      description: 'First choice of hospitals, labs, pharmacies, and clinics',
      features: [
        'Hospital deliveries',
        'Medical supply distribution',
        'Lab specimen transport',
        'Blood bank services',
        'HIPAA compliance',
        'Temperature monitoring'
      ],
      image: 'https://customer-assets.emergentagent.com/job_sabey-logistics/artifacts/xeuvmsp1_image.png'
    },
    {
      icon: Pill,
      title: 'Pharmaceutical Deliveries',
      description: 'Ensuring patients receive medications on time',
      features: [
        'Controlled substance handling',
        'Temperature-sensitive transport',
        'Chain of custody tracking',
        'DEA compliance',
        'Same-day delivery',
        'Secure packaging'
      ],
      image: 'https://images.pexels.com/photos/3683074/pexels-photo-3683074.jpeg'
    },
    {
      icon: FlaskRound,
      title: 'Specimen Transportation',
      description: 'Labs and specimens safely transported in controlled containers',
      features: [
        'Temperature-controlled containers',
        'Biohazard compliance',
        'Chain of custody',
        'Time-critical delivery',
        'Specialized packaging',
        'Real-time monitoring'
      ],
      image: 'https://images.unsplash.com/photo-1635091238012-83fb7454e8bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwc3BlY2ltZW4lMjBjb29sZXIlMjBiaW9oYXphcmQlMjB0cmFuc3BvcnQlMjBjb250YWluZXJ8ZW58MHx8fHwxNzY4MTMxMTU3fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Thermometer,
      title: 'Temperature Sensitive',
      description: 'Climate-controlled environments for sensitive cargo',
      features: [
        'Cold chain logistics',
        'Real-time temp monitoring',
        'Validated containers',
        'Documentation compliance',
        'Emergency protocols',
        'Multiple temp ranges'
      ],
      image: 'https://images.pexels.com/photos/5953713/pexels-photo-5953713.jpeg'
    },
    {
      icon: AlertTriangle,
      title: 'Dangerous Goods / HAZMAT',
      description: 'Certified hazardous materials handling and transportation',
      features: [
        'Full DOT compliance',
        'Hazmat certified personnel',
        'Specialized safety protocols',
        'Proper documentation',
        'Emergency response planning',
        'Class 1-9 materials'
      ],
      image: 'https://images.pexels.com/photos/4483610/pexels-photo-4483610.jpeg'
    },
    {
      icon: Lock,
      title: 'Armed Escort of High-Value Goods',
      description: 'Maximum security for your most valuable shipments',
      features: [
        'Armed security personnel',
        'GPS tracking',
        'Insurance coverage',
        'Secure facilities',
        'Background-checked teams',
        'Chain of custody'
      ],
      image: 'https://images.pexels.com/photos/14119497/pexels-photo-14119497.jpeg'
    },
    {
      icon: Building,
      title: 'White Glove Service',
      description: 'Premium delivery & installation services',
      features: [
        'Hospital installations',
        'Medical clinic setup',
        'Home delivery & install',
        'Unpacking & assembly',
        'Debris removal',
        'Scheduled appointments'
      ],
      image: 'https://customer-assets.emergentagent.com/job_sabey-logistics/artifacts/oxb6hklk_image.png'
    },
    {
      icon: Users,
      title: 'Two-Man Teams',
      description: 'Heavy and complex deliveries requiring team lift',
      features: [
        'Team lift capability',
        'Inside delivery',
        'Stair carry available',
        'Room of choice',
        'Equipment handling',
        'Professional service'
      ],
      image: 'https://images.pexels.com/photos/7464232/pexels-photo-7464232.jpeg'
    },
    {
      icon: Plane,
      title: 'Aerospace Logistics (AOG)',
      description: 'Aircraft on Ground - critical aviation support',
      features: [
        'AOG rapid response',
        '24/7 availability',
        'Airport-to-airport',
        'Parts expediting',
        'Global network',
        'FAA compliance'
      ],
      image: 'https://customer-assets.emergentagent.com/job_sabey-logistics/artifacts/gucq6baw_image.png'
    },
    {
      icon: Shield,
      title: 'TSA Certified Operations',
      description: 'Enhanced security for sensitive shipments',
      features: [
        'Full TSA certification',
        'Secure facilities',
        'Background-checked personnel',
        'Chain of custody tracking',
        'Compliance documentation',
        'Regulated material handling'
      ],
      image: 'https://customer-assets.emergentagent.com/job_sabey-logistics/artifacts/pl14p70t_ChatGPT%20Image%20Jan%2011%2C%202026%2C%2003_16_15%20AM.png'
    },
    {
      icon: Globe,
      title: 'International Shipping',
      description: 'Global shipping solutions via air freight',
      features: [
        'Air freight services',
        'Customs clearance',
        'Documentation support',
        'International tracking',
        'Duty & tax management',
        'Global carrier network'
      ],
      image: 'https://customer-assets.emergentagent.com/job_sabey-logistics/artifacts/wphyci6c_image.png'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-900 to-slate-700 text-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">Our Services</h1>
          <p className="text-lg sm:text-xl text-slate-200 max-w-3xl mx-auto">
            Comprehensive logistics solutions tailored to your business needs
          </p>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto space-y-24">
          {detailedServices.map((service, index) => {
            const Icon = service.icon;
            const isEven = index % 2 === 0;
            
            return (
              <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${!isEven ? 'lg:flex-row-reverse' : ''}`}>
                <div className={`${!isEven ? 'lg:order-2' : ''}`}>
                  <div className="bg-gradient-to-br from-slate-100 to-slate-50 w-16 h-16 rounded-xl flex items-center justify-center mb-6">
                    <Icon className="h-8 w-8 text-slate-700" />
                  </div>
                  <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4">{service.title}</h2>
                  <p className="text-base sm:text-lg text-slate-600 mb-6">{service.description}</p>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start space-x-2">
                        <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                        <span className="text-slate-700 text-sm sm:text-base">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <Link to="/contact">
                    <Button className="bg-slate-800 hover:bg-slate-700 text-white px-6 py-3 rounded-lg">
                      Learn More
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </Link>
                </div>
                
                <div className={`${!isEven ? 'lg:order-1' : ''}`}>
                  <Card className="overflow-hidden border-0 shadow-xl">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-[350px] sm:h-[400px] object-cover"
                    />
                  </Card>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-900 to-slate-700 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6">Need a Custom Solution?</h2>
          <p className="text-lg sm:text-xl text-slate-200 mb-8">
            Our team can design a logistics solution tailored specifically to your business requirements.
          </p>
          <Link to="/contact">
            <Button className="bg-white text-slate-900 hover:bg-slate-100 px-8 py-6 text-lg rounded-lg shadow-lg">
              Contact Our Team
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
